import { mapActions, mapState } from 'vuex'
import { setLocale } from '@/i18n'
import config from '@/config'
import { api } from '@/plugins/api'

export default {
  data () {
    return {
      isLoading: true,
      isForbidden: false,
      email: '',
      registered: false,
      guestRegistered: false,
      registerError: null,
      shouldShowAlert: false,
      requestIsLoading: false,
      sizingDialog: false,
      registerRules: {
        required: value => !!value || this.$t('error_required'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('error_email')
        }
      },
      registerItems: {
        experience: [
          { value: 1, label: this.$t('register_experience_1') },
          { value: 2, label: this.$t('register_experience_2') },
          { value: 3, label: this.$t('register_experience_3') },
          { value: 4, label: this.$t('register_experience_4') },
          { value: 5, label: this.$t('register_experience_5') }
        ],
        level: [
          { value: 1, label: this.$t('register_level_1') },
          { value: 2, label: this.$t('register_level_2') },
          { value: 3, label: this.$t('register_level_3') },
          { value: 4, label: this.$t('register_level_4') },
          { value: 5, label: this.$t('register_level_5') }
        ],
        sportLevel: [
          { value: 1, label: this.$t('register_sport_level_1') },
          { value: 2, label: this.$t('register_sport_level_2') },
          { value: 3, label: this.$t('register_sport_level_3') },
          { value: 4, label: this.$t('register_sport_level_4') },
          { value: 5, label: this.$t('register_sport_level_5') }
        ],
        position: [
          { value: 'handler', label: this.$t('register_position_handler') },
          { value: 'cutter', label: this.$t('register_position_cutter') },
          { value: 'both', label: this.$t('register_position_both') }
        ],
        bundle: [
          { value: 'simple', label: this.$t('register_bundle_simple') },
          { value: 'vege', label: this.$t('register_bundle_vege') },
          { value: 'meal', label: this.$t('register_bundle_meal') }
        ],
        shirt: [
          'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'
        ]
      },
      registerForm: {
        firstName: '',
        lastName: '',
        nickName: '',
        pesel: '',
        email: '',
        phone: '',
        city: '',
        country: 'Polska',
        team: '',
        experience: '',
        level: '',
        sportLevel: '',
        position: '',
        shirt: '',
        bundle: '',
        others: '',
        over18: false,
        truthAcceptance: false,
        publicationAcceptance: false,
        rulesAcceptance: false,
        disc: false
      }
    }
  },
  computed: {
    ...mapState(['authToken', 'user', 'players', 'matches', 'timelines', 'teams', 'content', 'shopItems', 'shopOrders', 'webVersion']),
    isRegister () {
      const now = (new Date()).toISOString().substring(0, 16)
      const end = '2023-09-20T06:00'
      return now < end && !(this.$route && this.$route.name === 'homeTest')
    },
    isGuestAvailable () {
      const now = (new Date()).toISOString().substring(0, 16)
      const end = '2023-10-08T22:00'
      return !this.isRegister && now < end
    },
    updateNeeded () {
      return !this.isForbidden && this.webVersion > config.VERSION
    }
  },
  methods: {
    ...mapActions(['loadData']),
    switchLang () {
      setLocale(this.$i18n.locale === 'pl' ? 'en' : 'pl')
    },
    logout () {
      window.localStorage.removeItem('dc2023-token')
      window.location = '/'
    },
    sendAccess () {
      if (this.$refs.accessForm.validate()) {
        this.registered = false
        this.requestIsLoading = true
        return api.requestAccess({ email: this.email }).then(() => {
          this.requestIsLoading = false
          this.registered = true
          this.email = ''
        }).catch(() => {
          this.requestIsLoading = true
        })
      }
    },
    registerPlayer () {
      this.registerError = null
      this.registered = false
      this.shouldShowAlert = !this.$refs.registerForm.validate()
      if (!this.shouldShowAlert) {
        this.requestIsLoading = true
        return api.register({ ...this.registerForm, lang: this.$i18n.locale }).then(() => {
          this.requestIsLoading = false
          this.registered = true
        }).catch(e => {
          this.shouldShowAlert = true
          try {
            this.registerError = e.response.data.validation.email === 'exists' ? this.$t('register_error_message_email') : null
            if (!this.registerError) {
              this.registerError = e.response.data.validation.registration === 'finished' ? this.$t('register_error_message_registration_finished') : null
            }
          } catch (e) {}
          this.requestIsLoading = false
        })
      }
    },
    registerGuest () {
      this.registerError = null
      this.guestRegistered = false
      this.shouldShowAlert = !this.$refs.guestForm.validate()
      if (!this.shouldShowAlert) {
        this.requestIsLoading = true
        return api.registerGuest({ ...this.registerForm }).then(() => {
          this.requestIsLoading = false
          this.guestRegistered = true
        }).catch(e => {
          this.shouldShowAlert = true
          try {
            this.registerError = e.response.data.validation.email === 'exists' ? this.$t('register_error_message_email') : null
            if (!this.registerError) {
              this.registerError = e.response.data.validation.registration === 'finished' ? this.$t('register_error_message_registration_finished') : null
            }
          } catch (e) {}
          this.requestIsLoading = false
        })
      }
    }
  },
  created () {
    if (!this.authToken) {
      this.isForbidden = true
      return
    }

    this.loadData().then(() => {
      this.isLoading = false
    }).catch(e => {
      this.isForbidden = true
    })
  }
}
